import { DateTime } from "luxon";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import { useIsLoading } from "shared/hooks/requestStatusHooks";

import { getCase } from "app/actions/caseActions";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useGroupedOrdersByExternalLab } from "hooks/useOrders";
import { useSelectedLabStation } from "hooks/useSelectedLabStation";
import Spinner from "ui/components/Spinner";

import SendoutRequisition from "./SendoutRequisition";

const SendoutRequisitionPage = () => {
  const dispatch = useAppDispatch();
  const selectedLabStationId = useSelectedLabStation().id;
  const case_id = Number(useParams().case_id);

  const pathCase = useAppSelector((state) => state.case);
  const loadingCase = useIsLoading(getCase, {
    id: case_id,
    parentLookupLabStationId: selectedLabStationId,
  });
  const orders =
    pathCase?.lab_orders?.filter((o) => !o.completed_at && !o.cancelled_at) ||
    [];

  const ordersByExternalLab = useGroupedOrdersByExternalLab(orders);

  // TODO: Feels repetitive for "sub routes", maybe we need some kind of controller component
  useEffect(() => {
    if (case_id && (!pathCase?.id || case_id !== pathCase?.id)) {
      dispatch(
        getCase({ id: case_id, parentLookupLabStationId: selectedLabStationId })
      );
    }
  }, [case_id, pathCase?.id]);

  const [showLocalOrders, setShowLocalOrders] = useState<boolean>(false);
  const localOrdersRef = useRef<HTMLDivElement>(null);
  const localOrdersAvailable = ordersByExternalLab?.[0];

  useLayoutEffect(() => {
    if (showLocalOrders) localOrdersRef.current?.scrollIntoView();
  }, [showLocalOrders]);

  return loadingCase ? (
    <Spinner />
  ) : pathCase?.id ? (
    <div className="SendoutRequisitionPage">
      <Helmet>
        <title>{`Sendout Requisitions for ${
          pathCase?.accession
        } (${DateTime.now().toFormat("MM-dd-yyyy")})`}</title>
      </Helmet>
      <div className="SendoutRequisitions">
        {Object.entries(ordersByExternalLab)
          .filter(([externalLabId, _]) => Number(externalLabId))
          .map(([externalLabId, orders]) => (
            <SendoutRequisition
              key={externalLabId}
              lisCase={pathCase}
              orders={orders}
              externalLabId={Number(externalLabId)}
            />
          ))}
      </div>

      {localOrdersAvailable && (
        <div className="SendoutRequisitions__toggle">
          <button
            onClick={() => {
              setShowLocalOrders((s) => !s);
            }}
          >
            {showLocalOrders ? "Hide" : "Send Out"} "In-House" Orders
          </button>
        </div>
      )}
      {showLocalOrders && localOrdersAvailable && (
        <div className="SendoutRequisitions" ref={localOrdersRef}>
          <SendoutRequisition
            lisCase={pathCase}
            orders={ordersByExternalLab[0]}
          />
        </div>
      )}
    </div>
  ) : null;
};

export default SendoutRequisitionPage;
